import moment from 'moment';
import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {Alert, Button, Input, Label} from 'reactstrap';
import trainingPhasesActionCreators from '../../store/training-phases/action-creators/index';
import CheckActionButton from '../common/CheckActionButton';
import DateSelector from '../common/DateSelector';
import TimeSelector from '../common/TimeSelector';

class ScheduleReports extends Component {
  constructor(props) {
    super(props);
    const now = new Date();
    this.state = {
      properties: {
        observationDate: now.toISOString(),
        reports: [],
        submittedBy: now.toISOString(),
        type: 'dor',
      },
    };

  }

  // ----------------------
  // Handlers
  // ----------------------

  onDateSelectorChanged(date) {
    const hours = moment(this.state.properties.observationDate).hours();
    const minutes = moment(this.state.properties.observationDate).minutes();
    const observationDate = moment(date)
      .hours(hours)
      .minutes(minutes);
    this.setState(state => ({
      properties: {
        ...state.properties,
        observationDate,
      },
    }));
  }

  onTimeSelectorChanged(date) {
    const year = moment(this.state.properties.observationDate).year();
    const month = moment(this.state.properties.observationDate).month();
    const dateOfMonth = moment(this.state.properties.observationDate).date();
    const observationDate = moment(date)
      .year(year)
      .month(month)
      .date(dateOfMonth);
    this.setState(state => ({
      properties: {
        ...state.properties,
        observationDate,
      },
    }));
  }

  // ----------------------
  // Computed
  // ----------------------

  get isFormDisabled() {
    return this.state.properties.reports.length === 0;
  }

  get submittedHour() {
    const hours = new Date(this.state.submittedBy).getHours();
    return hours > 12 ? hours.toString() : (hours - 12).toString();
  }

  get submittedMinutes() {
    const minutes = new Date(this.state.submittedBy).getMinutes();
    return minutes.toString();
  }

  // ----------------------
  // Methods
  // ----------------------

  addScheduleToList() {
    const submittedByHours = moment(this.state.properties.submittedBy).hours();
    const submittedByMinutes = moment(this.state.properties.submittedBy).minutes();
    const submittedBy = moment(this.state.properties.observationDate)
      .hours(submittedByHours)
      .minutes(submittedByMinutes);
    const added = {
      schedule: {
        observationDate: this.state.properties.observationDate,
        submittedBy: submittedBy.toISOString(),
      },
      type: this.state.properties.type,
    };
    this.setState((state) => {
      const observationDate = moment(state.properties.observationDate);
      const dateOfMonth = observationDate.date();
      return {
        properties: {
          ...state.properties,
          observationDate: observationDate.date(dateOfMonth + 1).toISOString(),
          reports: [added, ...state.properties.reports],
        },
      };
    });
  }

  handleInput(name, value) {
    this.setState(state => ({
      properties: { ...state.properties, [name]: value },
    }));
  }

  handleSubmit() {
    this.props.createScheduledReports({
      reports: this.state.properties.reports,
      trainingPhaseGuid: this.props.selectedPhaseGuid,
    });
  }

  removeScheduleFromList(index) {
    this.setState((state) => {
      const { reports } = state.properties;
      reports.splice(index, 1);
      return {
        properties: {
          ...state.properties,
          reports,
        },
      };
    });
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <Fragment>
        <table className="table table-stripped">
          <thead>
            <tr>
              <th>
                <div className="header">
                  <span>Observation Date </span>
                </div>
              </th>
              <th>
                <div className="header">
                  <span>Type </span>
                </div>
              </th>
              <th>
                <div className="header">
                  <span>Submitted By </span>
                </div>
              </th>
              <th>
                <div className="header">
                  <span>Actions </span>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <DateSelector
                  date={this.state.properties.observationDate}
                  onChange={date => this.onDateSelectorChanged(date)}
                />
              </td>
              <td>
                <div className="form-inline" name="type">
                  <Label className="sr-only" for="type" />
                  <Input
                    name="type"
                    onChange={event =>
                      this.handleInput(event.target.name, event.target.value)
                    }
                    type="select"
                    value={this.state.type}
                  >
                    <option value="dor">Daily Observation</option>
                    <option value="eop">End of Phase Observation</option>
                    <option value="wor">Weekly Observation</option>
                  </Input>
                </div>
              </td>
              <td>
                <TimeSelector
                  date={this.state.properties.observationDate}
                  onChange={date => this.onTimeSelectorChanged(date)}
                />
              </td>
              <td>
                <CheckActionButton
                  onAdd={() => this.addScheduleToList()}
                  label="Add"
                />
              </td>
            </tr>
            {this.state.properties.reports.length === 0 ? (
              <Fragment>
                <tr>
                  <td colSpan="4">
                    <Alert color="primary">No scheduled reports to add</Alert>
                  </td>
                </tr>
              </Fragment>
            ) : (
              <Fragment>
                {this.state.properties.reports.map((report, index) => (
                  <tr key={index.toString()}>
                    <td>
                      {moment(report.schedule.observationDate).format('MMM D, YYYY')}
                    </td>
                    <td>{report.type}</td>
                    <td>
                      {moment(report.schedule.observationDate).format('HH:mm')}
                    </td>
                    <td>
                      <button
                        className="button primary small"
                        onClick={() => this.removeScheduleFromList(index)}
                      >
                        <i className="fa fa-times" />
                        Remove
                      </button>
                    </td>
                  </tr>
                ))}
              </Fragment>
            )}
          </tbody>
        </table>
        <div style={{ textAlign: 'right' }}>
          <Button
            color="primary"
            disabled={this.isFormDisabled}
            onClick={() => this.handleSubmit()}
          >
            Schedule Reports
          </Button>
        </div>
      </Fragment>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    selectedPhaseGuid: state.trainingPhases.selectedGuid,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    createScheduledReports: (formData) => {
      return dispatch(trainingPhasesActionCreators.createScheduledReports(formData));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleReports);
